// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { forwardRef, Ref } from "react";
import { IconProps, Svg } from "@/frameworks/designStuff/components/Contents/Icon";
const SvgVote24 = forwardRef(({ size, title, desc, titleid, descid, ...props }: IconProps, ref: Ref<SVGSVGElement>) => {
	let ariaLabelledBy = titleid ? titleid : "";
	ariaLabelledBy += desc && descid ? ` ${descid}` : "";
	ariaLabelledBy = ariaLabelledBy ? ariaLabelledBy : undefined;
	props["aria-labelledby"] = ariaLabelledBy;
	return (
		<Svg
			width={size}
			height={size}
			viewBox="0 0 24 24"
			xmlns="http://www.w3.org/2000/svg"
			title={title}
			titleid={titleid}
			desc={desc}
			descid={descid}
			aria-labelledby={ariaLabelledBy}
			aria-hidden={!ariaLabelledBy}
			ref={ref}
			{...props}
		>
			{!!title && <title id={titleId}>{title}</title>}
			{!!desc && <desc id={descId}>{desc}</desc>}
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M12.4243 3.28418C12.6912 2.95493 13.1745 2.9044 13.5038 3.17131L19.8126 8.2857C20.1361 8.54792 20.1914 9.02024 19.9373 9.35013L16.1592 14.2556H18.8217C19.0783 14.2556 19.3179 14.3839 19.4603 14.5974L22.8711 19.7136C23.0281 19.9491 23.0428 20.2519 22.9092 20.5015C22.7757 20.751 22.5156 20.9068 22.2326 20.9068H1.76744C1.48441 20.9068 1.22436 20.751 1.09081 20.5015C0.95726 20.2519 0.971897 19.9491 1.12889 19.7136L4.53975 14.5974C4.68208 14.3839 4.9217 14.2556 5.1783 14.2556H6.68772C6.29697 13.9406 5.86897 13.5948 5.37705 13.196C5.0478 12.9291 4.99726 12.4458 5.26418 12.1166L12.4243 3.28418ZM14.3861 16.558L14.9771 15.7905H18.411L20.7986 19.3719H3.20142L5.58902 15.7905H8.5966C8.8996 16.0341 9.21109 16.2848 9.54942 16.558H7.39535C7.11279 16.558 6.88373 16.787 6.88373 17.0696C6.88373 17.3521 7.11279 17.5812 7.39535 17.5812H16.6047C16.8872 17.5812 17.1163 17.3521 17.1163 17.0696C17.1163 16.787 16.8872 16.558 16.6047 16.558H14.3861ZM12.4487 16.558L18.2646 9.00662L13.1333 4.84691L6.94005 12.4866C7.74906 13.1409 8.36732 13.6375 8.97441 14.1251L8.9746 14.1252L8.97469 14.1253L9.44238 14.5008C10.1952 15.105 11.3314 16.0171 11.9996 16.558H12.4487Z"
			/>
		</Svg>
	);
});
SvgVote24.defaultProps = {
	size: 24,
	focusable: false,
	"aria-hidden": true,
	role: "img",
	fill: "currentcolor"
};
export default SvgVote24;
